// import {gql, useMutation} from '@apollo/client'
// import {useState} from 'react'
// import Button from './Button'
// import {useSessionStorageState} from '../utils/useSessionStorageState'
// import {Loading} from './Loading'
// import {CheckIcon, XIcon, SparklesIcon} from '@heroicons/react/outline'
import {scents} from '../utils/helpers'
import {useState, useEffect} from 'react'
import {useQuery} from '@apollo/client'
import {PortalOrderByIdQuery} from '../apollo/queries'
import { fetchCustomAirFreshenerProduct } from '../apollo/shopifyApi'

// console.log('shopi', shopifyClient)

type Props = {
  replacementError?: (scent: string) => void
  setFirst?: (scent: string) => void
  currentScent: string
  setNewScent?: (scent: string) => void
  type?: string
}

const ScentAction: React.FC<Props> = ({
  replacementError,
  setFirst,
  currentScent,
  setNewScent,
  type = 'new',
}) => {
  const [newScent, setnewScent] = useState([])
  const [scentnew, setscentnew] = useState(null)
  const [ScentItem, setScentItem] = useState()
  const filteredScent = newScent.filter(sc => sc !== 'Select A Scent')

  async function buyIt() {
    try {
      const product = await fetchCustomAirFreshenerProduct()
      const scentValues = product.options.find(opt => opt.name === 'Scent')?.values || []
      setnewScent(scentValues)
    } catch (error) {
      console.error('Error fetching scent options:', error)
    }
  }
  
  useEffect(() => {
    buyIt()
  }, [])

  useEffect(() => {
    const match = filteredScent.find(el => el === currentScent)
    if (match) {
      setscentnew(match)
      setFirst?.(match)
    }
  }, [filteredScent, currentScent])

  return (
    <div tw="">
      {/* <h3 tw="text-lg text-brand ">{type} Scent</h3> */}
      <h3 tw="text-lg text-brand ">{type && type == "Replacement" ? "Replacement Scent" : "Scent"}</h3>
      <div tw="flex-shrink-0 font-normal text-gray-500">
        <div className="select-box">
          <span className="select-icon">
            <i className="fa fa-caret-down"></i>
          </span>
          <select
            value={!scentnew ? 'Select A Scent' : currentScent}
            onChange={e => setNewScent(e.currentTarget.value)}
            className="input-styling"
            tw="h-full w-full p-2 bg-white focus:ring-brand"
          >
            {!scentnew && <option>Select A Scent</option>}
            {/* {scents.map(scent => (
            <option key={scent.value} value={scent.value}>
              {scent.label}
            </option>
          ))} */}
            {filteredScent.map(value => (
              <option key={value} value={value}>
                {value}
              </option>
            ))}
          </select>
        </div>
        {!scentnew && (
          <span style={{color: 'red'}}>{replacementError}</span>
        )}
      </div>
    </div>
  )
}

export default ScentAction
